<template functional>
  <span>{{ $options.licenceCategoryName(props.person) }}</span>
</template>

<script>
import gql from "fraql";
export default {
  name: "AppShowPersonLicenceCategory",
  props: {
    person: {
      type: Object,
      default: null
    }
  },
  fragments: {
    person: gql`
      fragment _ on Person {
        currentSeasonLicenceValid
        validLicence {
          id
          paidAt
          licenceCategoryId
          licenceCategory @client {
            id
            name
          }
        }
      }
    `,
    licenceCategory: gql`
      fragment _ on LicenceCategory {
        id
        name
      }
    `
  },
  licenceCategoryName(person) {
    return person?.validLicence?.licenceCategory?.name ?? "";
  }
};
</script>
